import { Component } from '@angular/core';

@Component({
  selector: 'pay-spinner',
  imports: [],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {}
